export default __webpack_public_path__ + "images/e12ef2515f7999db21793c2a9e1e49ce-beauty_small.webp";